module.exports = __webpack_public_path__ + "static/img/abc-map.3a52f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gotoContent/abc-map.png
// module id = V6Di
// module chunks = 0